import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, getLista, getListaProducao } from './relatorioRadiologistaSinteticoActions';
import { getLista as getListaHospital } from '../hospital/hospitalActions';
import { getLista as getListaRadiologista } from '../radiologista/radiologistaActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

class RelatorioRadiologistaSintetico extends Component {

	state = {
		linhaSelecionada: null,
		ano: new Date().getFullYear()
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaProducao();
		this.props.getListaHospital();
		this.props.getListaRadiologista();
    }

	render() {
		return (
			<Content>
				<Aguardando aguardando={this.props.aguardando} />

				<ContentCard>
					<ContentCardHeader>
						<Row>
							<Select
								options={[{ id: 2025, valor: 2025 }, { id: 2026, valor: 2026 }, { id: 2027, valor: 2027 }]}
								label='Ano *'
								cols='12 6 4 3'
								placeholder='Selecione'
								minWidth={300}
								value={this.state.ano}
								onChange={value => {
									this.setState({
										...this.state,
										ano: value
									});
								}} />

							<Select
								options={this.props.listaRadiologista}
								label='Radiologista *'
								cols='12 6 4 3'
								placeholder='Selecione'
								minWidth={300}
								value={this.state.id_radiologista}
								onChange={value => {
									this.setState({
										...this.state,
										id_radiologista: value
									});
								}} />

							<div style={{ width: 110, marginTop: 8, marginLeft: 8 }}>
								<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
									onClick={() => {
										this.props.getLista({
											ano: this.state.ano,
											id_radiologista: this.state.id_radiologista
										});
										this.props.getListaProducao({
											ano: this.state.ano,
											id_radiologista: this.state.id_radiologista
										});
									}}>
									<i class='fas fa-sync-alt'></i> Atualizar
								</a>
							</div>
						</Row>
					</ContentCardHeader>
				</ContentCard>

				{this.listaValores()}

				{this.listaProducoes()}

			</Content>
		)
	}

    listaValores() {

		let valorTotal = 0;
		let valorImpostoTotal = 0;
		let valorImpostoEscritorioTotal = 0;
		let valorLiquidoTotal = 0;

        return (
			<ContentCard>
				<ContentCardBody>
					<Table responsive striped border>
						<THead>
							<Tr>
								<Th alignLeft>Mês</Th>
								<Th alignRight>Total Bruto</Th>
								<Th alignRight>Imposto</Th>
								<Th alignRight>Administração</Th>
								<Th alignRight>Líquido</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => {

								valorTotal += parseFloat(item.valor);
								valorImpostoTotal += parseFloat(item.valor_imposto);
								valorImpostoEscritorioTotal += parseFloat(item.valor_imposto_escritorio);
								valorLiquidoTotal += parseFloat(item.valor_liquido);

								return (
									<Tr key={`${item.competencia}`}>
										<Td alignLeft>{item.mes}</Td>
										<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor, 2)}</Td>
										<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_imposto, 2)}</Td>
										<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_imposto_escritorio, 2)}</Td>
										<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_liquido, 2)}</Td>
									</Tr>
								);
							})}
							<Tr>
								<Td bold alignLeft backgroundColor='#dedede'>Total</Td>
								<Td alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotal, 2)}</Td>
								<Td alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorImpostoTotal, 2)}</Td>
								<Td alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorImpostoEscritorioTotal, 2)}</Td>
								<Td alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorLiquidoTotal, 2)}</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>                
        )
    }

	listaProducoes() {

		let janeiroTotal = 0;
		let fevereiroTotal = 0;
		let marcoTotal = 0;
		let abrilTotal = 0;
		let maioTotal = 0;
		let junhoTotal = 0;
		let julhoTotal = 0;
		let agostoTotal = 0;
		let setembroTotal = 0;
		let outubroTotal = 0;
		let novembroTotal = 0;
		let dezembroTotal = 0;

        return (
            <ContentCard>
				<ContentCardBody>
					<Table responsive striped border>
						<THead>
							<Tr>
								<Th alignCenter>Exame</Th>
								<Th alignCenter>Janeiro</Th>
								<Th alignCenter>Fevereiro</Th>
								<Th alignCenter>Março</Th>
								<Th alignCenter>Abril</Th>
								<Th alignCenter>Maio</Th>
								<Th alignCenter>Junho</Th>
								<Th alignCenter>Julho</Th>
								<Th alignCenter>Agosto</Th>
								<Th alignCenter>Setembro</Th>
								<Th alignCenter>Outubro</Th>
								<Th alignCenter>Novembro</Th>
								<Th alignCenter>Dezembro</Th>
								<Th alignCenter backgroundColor='#c2bebe'>Total</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaProducao.map(item => {

								janeiroTotal += parseInt(item.janeiro || 0);
								fevereiroTotal += parseInt(item.fevereiro || 0);
								marcoTotal += parseInt(item.marco || 0);
								abrilTotal += parseInt(item.abril || 0);
								maioTotal += parseInt(item.maio || 0);
								junhoTotal += parseInt(item.junho || 0);
								julhoTotal += parseInt(item.julho || 0);
								agostoTotal += parseInt(item.agosto || 0);
								setembroTotal += parseInt(item.setembro || 0);
								outubroTotal += parseInt(item.outubro || 0);
								novembroTotal += parseInt(item.novembro || 0);
								dezembroTotal += parseInt(item.dezembro || 0);

								return (
									<Tr key={item.id_exame}>
										<Td alignCenter>{item.nome_exame}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.janeiro, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.fevereiro, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.marco, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.abril, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.maio, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.junho, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.julho, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.agosto, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.setembro, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.outubro, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.novembro, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(item.dezembro, 0)}</Td>
										<Td alignCenter bold backgroundColor='#c2bebe'>{FormatUtils.formatarValorTelaDecimal(
											item.janeiro + item.fevereiro + item.marco + item.abril + item.maio + item.junho
											+ item.julho + item.agosto + item.setembro + item.outubro + item.novembro + item.dezembro, 0)
										}</Td>
									</Tr>
								);
							})}
							<Tr>
								<Td alignCenter bold backgroundColor='#dedede'>Total</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(janeiroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(fevereiroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(marcoTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(abrilTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(maioTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(junhoTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(julhoTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(agostoTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(setembroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(outubroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(novembroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(dezembroTotal, 0)}</Td>
								<Td alignCenter bold backgroundColor='#c2bebe'>{FormatUtils.formatarValorTelaDecimal(
									janeiroTotal + fevereiroTotal + marcoTotal + abrilTotal + maioTotal + junhoTotal + 
									julhoTotal + agostoTotal + setembroTotal + outubroTotal + novembroTotal + dezembroTotal, 0)
								}</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
        )
    }
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.relatorioRadiologistaSintetico.modoTela,
	aguardando: state.relatorioRadiologistaSintetico.aguardando,
	lista: state.relatorioRadiologistaSintetico.lista,
	listaProducao: state.relatorioRadiologistaSintetico.listaProducao,
	listaHospital: state.hospital.listaSelect,
	listaRadiologista: state.radiologista.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, getLista, getListaProducao, getListaHospital, getListaRadiologista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(RelatorioRadiologistaSintetico);